import Media from '@linc-technologies/linced-common/models/media';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Globalnotice from '@linc-technologies/linced-common/models/posts/globalnotice';
import type Communitynotice from 'linced-app/models/posts/communitynotice';
import type Staffnotice from 'linced-app/models/posts/staffnotice';
import type Studentnotice from 'linced-app/models/posts/studentnotice';
import type Text from 'linced-app/models/posts/text';

// Proto: media.MediaMeta.
export default class _Media extends Media {
  declare [Type]: 'media';

  @belongsTo('posts/communitynotice', { async: true, inverse: 'mediaIds' })
  declare communityNoticeId: AsyncBelongsTo<Communitynotice>;

  @belongsTo('posts/studentnotice', { async: true, inverse: 'mediaIds' })
  declare studentNoticeId: AsyncBelongsTo<Studentnotice>;

  @belongsTo('posts/staffnotice', { async: true, inverse: 'mediaIds' })
  declare staffNoticeId: AsyncBelongsTo<Staffnotice>;

  @belongsTo('posts/globalnotice', { async: true, inverse: 'mediaIds' })
  declare globalNoticeId: AsyncBelongsTo<Globalnotice>;

  // Text posts never attach media, but need their own dedicated inverse
  // field (rather than inheriting Post's shared `postId`/`mediaIds`) to
  // satisfy Ember Data's relationship schema validation for the `Text`
  // subclass. This will always resolve empty since the API never returns
  // a `text_id` on media.
  @belongsTo('posts/text', { async: true, inverse: 'mediaIds' })
  declare textId: AsyncBelongsTo<Text>;
}
